import { Box, CircularProgress } from '@mui/material';
import { AccessDenied } from 'react-admin';

import FilesPage from './FilesPage';
import { useSftpFoldersConfigured } from './useSftpFoldersConfigured';

/**
 * Guards the /files route on SFTP folder mapping configuration, mirroring the
 * check CustomMenu uses to decide whether to show the Files nav item.
 * Without this, navigating to /files directly bypasses the hidden nav item.
 */
const FilesRouteGuard = () => {
  const { isConfigured, isLoading } = useSftpFoldersConfigured();

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  if (!isConfigured) {
    return <AccessDenied />;
  }

  return <FilesPage />;
};

export default FilesRouteGuard;
